import { render, staticRenderFns } from "./remote.vue?vue&type=template&id=2ecab447"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"
import style0 from "./remote.vue?vue&type=style&index=0&id=2ecab447&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-load_0b7ff5153dda3b71f22745c8daebd203/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports